import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import Layout from './components/Layout'
import AppLayout from './components/AppLayout'
import Login from './pages/Login'
import AppsList from './pages/AppsList'
import AppDashboard from './pages/AppDashboard'
import Devices from './pages/Devices'
import Versions from './pages/Versions'
import GrayRelease from './pages/GrayRelease'
import Stats from './pages/Stats'
import ProtectedRoute from './components/ProtectedRoute'

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* 登录页 */}
          <Route path="/login" element={<Login />} />
          
          {/* 应用列表（无侧边栏） */}
          <Route path="/apps" element={
            <ProtectedRoute>
              <AppsList />
            </ProtectedRoute>
          } />
          
          {/* 主布局：应用列表 */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/apps" replace />} />
          </Route>
          
          {/* 应用布局：应用内部管理 */}
          <Route path="/apps/:appId" element={<AppLayout />}>
            <Route index element={<AppDashboard />} />
            <Route
              path="devices"
              element={
                <ProtectedRoute>
                  <Devices />
                </ProtectedRoute>
              }
            />
            <Route
              path="versions"
              element={
                <ProtectedRoute>
                  <Versions />
                </ProtectedRoute>
              }
            />
            <Route
              path="gray-release"
              element={
                <ProtectedRoute>
                  <GrayRelease />
                </ProtectedRoute>
              }
            />
            <Route
              path="stats"
              element={
                <ProtectedRoute>
                  <Stats />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
